import { Link } from '@/app_components/common/Link';

interface DisclaimerProps {
  ctaUrl: string;
}

export const Disclaimer = ({ ctaUrl: ctaLink }: DisclaimerProps) => {
  return (
    <div
      className='flex justify-center shadow-[inset_0_-4px_20px_0_rgba(1,1,1,0.06)] px-4 py-2 border-b border-[#D1D1D6] sticky top-[calc(var(--leaderboard-height)+var(--header-height))] bg-primary cursor-default z-[699]'
      data-cy='ez-newswire-disclaimer'
    >
      <div className='text-left text-primary font-graphik-compact font-normal typography-sm lg:text-base'>
        Sponsored content by{' '}
        <Link
          className='underline'
          href={`${ctaLink}&utm_content=disclaimer_link`}
          target='_blank'
          data-cy='ez-newswire-disclaimer-link'
        >
          EZ Newswire
        </Link>
        . The Fortune staff was not involved in producing this content.
      </div>
    </div>
  );
};
